var exports = {
  "qS": "SettingsStatusBadge.module__badge___dGFLRU",
  "Hl": "SettingsStatusBadge.module__new___dGFLRU",
  "ny": "SettingsStatusBadge.module__experimental___dGFLRU",
  "jp": "SettingsStatusBadge.module__badges___dGFLRU",
};

module.exports = exports;
